<template>
  <a-card title="限时团购" :bordered="false">
    <a-button type="primary" @click="addProductEvent" style="margin-bottom: 20px">添加商品</a-button>
    <custom-page-table
      ref="table"
      :query-params="queryParams"
      query-path="limit/group/selectList"
      base-key="apiUrl"
      :columns="getColumns()"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="toEditor(rowItem.record)">修改</a>
        <a-divider type="vertical"></a-divider>
        <a-popconfirm title="是否要删除当前商品？" @confirm="deleteEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
    </span>
    </custom-page-table>
    <a-modal
      title="添加推荐"
      okText="保存设置"
      :width="800"
      v-model="showDialog"
      @ok="saveEvent"
      @cancel="showDialog=false"
      :confirmLoading="saveLoading"
    >
      <a-form-model
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
        ref="form"
        :model="ruleForm"
        :rules="rules"
      >
        <a-form-model-item label="关联商品" :required="true" prop="limitProId">
          <span>
            <a-button type="primary" @click="toSelectedProduct">选择商品</a-button>
            <span v-if="ruleForm.limitProId" style="margin-left: 20px">商品ID：{{ ruleForm.limitProId }}</span>
          </span>
        </a-form-model-item>
        <a-form-model-item label="商品标题" prop="limitProName">
          <a-input
            v-model="ruleForm.limitProName"
            style="width: 100%"
            placeholder="商品标题"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="排序" prop="limitSequence">
          <a-input-number
            v-model="ruleForm.limitSequence"
            style="width: 100%"
            :min="1" :max="1000000"
            placeholder="整数数字越小越靠前"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="价格" prop="limitPrice">
          <a-input-number
            v-model="ruleForm.limitPrice"
            style="width: 100%"
            :min="1" :max="1000000"
            placeholder="支持两位小数"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="初始销量" prop="limitInitialSales">
          <a-input-number
            v-model="ruleForm.limitInitialSales"
            style="width: 100%"
            :min="0"
            placeholder="正整数"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="商品封面图" prop="limitProImg">
          <span>注意：图片上传尺寸为 690px*359px 上传图片格式为.jpg .jpg.gif</span>
          <br>
          <a-upload
            v-model="ruleForm.limitProImg"
            :action="uploadFileUrl"
            :multiple="false"
            :showUploadList="false"
            listType="picture-card"
            @change="fileInfo=>handleChange(fileInfo)"
            :before-upload="handleBeforeUploadImage"
          >
            <img v-if="ruleForm.limitProImg" :src="ruleForm.limitProImg" alt="avatar" class="image"/>
            <div v-else>
              <a-icon :type="uploading? 'loading' : 'plus'"/>
            </div>
          </a-upload>
        </a-form-model-item>
      </a-form-model>

    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      query-path="limit/group/selectRelatedList"
      base-key="apiUrl"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item
        label="商品ID"
        slot="search_proId" v-bind="currentFormLayout">
        <a-input
          v-model="selectedQueryParams.limitProId"
          style="width: 170px"
          placeholder="请输入商品ID"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="商品名称"
        slot="search_proName"
        v-bind="currentFormLayout">
        <a-input
          v-model="selectedQueryParams.limitProName"
          style="width: 170px"
          placeholder="请输入商品名称"
        ></a-input>
      </a-form-item>
      <template slot="limitProCatalogId" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>

</template>

<script>
import formMixin from '@/utils/mixins/formMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'GroupPurchaseList',
  mixins: [formMixin],

  components: { SelectedProductDialog },
  mounted() {
  },
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      queryParams: {},
      selectedQueryParams: {},
      showDialog: false,
      uploading: false,
      proImageUrl: '',
      ruleForm: {
        limitId: 0,// 主键id 修改+删除+详情必填 ,
        limitInitialSales: '',// 初始销量 新增+修改必填 ,
        limitMerchantId: '',// 运营商id 新增+修改+列表查询必填 ,
        limitPrice: '',// 价格 新增+修改必填 ,
        limitProCatalogId: '',// 关联商品种类 新增+修改必填 ,
        limitProId: '',// 关联商品ID 新增+修改必填 ,
        limitProImg: '',// 商品封面图 新增+修改必填 ,
        limitProName: '',// 商品标题 新增+修改必填 ,
        limitSequence: ''// 排序 新增+修改必填
      },
      rules: {
        limitProId: [
          { required: true, message: '请选择关联的商品', trigger: 'blur' }
        ],
        limitProName: [
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        limitSequence: [
          { required: true, message: '请输入商品排序值', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是大于0的正整数！', trigger: 'blur' }
        ],
        limitPrice: [
          { required: true, message: '请输入商品价格', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '必须是大于0的数字(可带两位小数)！',
            trigger: 'blur'
          }
        ],
        limitInitialSales: [
          { required: true, message: '请输入商品初始销量', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是大于0的正整数！', trigger: 'blur' }
        ],
        limitProImg: [
          { required: true, message: '请选择商品封面图片', trigger: 'change' }
        ]
      },
      showSelectedDialog: false
    }
  },

  created() {
    this.queryParams.limitMerchantId = this.$store.getters.userInfo.merchantId
    this.selectedQueryParams = { ...this.queryParams, state: 1 }
  },
  methods: {
    addProductEvent() {
      this.ruleForm = {}
      this.showDialog = true
    },
    toEditor(record) {
      this.getLogUtils().logWithTag('toEditor', record)
      this.getHttpServices().getApiService().post('/limit/group/queryDetail', { limitId: record.limitId })
        .then(detail => {
          this.ruleForm = { ...detail }
          this.showDialog = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    deleteEvent(record) {
      this.getHttpServices().getApiService().post('limit/group/delete', { limitId: record.limitId })
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.table.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getColumns() {
      return [
        {
          title: '排序',
          dataIndex: 'limitSequence',
          width: '120px'
        },
        {
          title: '标题',
          dataIndex: 'limitProName'
        },
        {
          title: '价格',
          dataIndex: 'limitPrice',
          width: '160px'
        },
        {
          title: '初始销量',
          dataIndex: 'limitInitialSales',
          width: '160px'
        },
        {
          title: '创建时间',
          dataIndex: 'limitCreateTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'limitProId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'limitProName'
        },
        {
          title: '商品分类',
          dataIndex: 'limitProCatalogId',
          width: '100px',
          scopedSlots: { customRender: 'limitProCatalogId' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    //文件变更监听
    handleChange(fileInfo) {
      if (fileInfo.file.status === 'uploading') {
        this.uploading = true
      } else if (fileInfo.file.status === 'done') {
        const url = this.getLatestUrlFromFileList(fileInfo.fileList)
        this.getLogUtils().logWithTag('======url========')
        this.ruleForm.limitProImg = url//上传后的图片地址
        this.uploading = false
      }
    },
    toSelectedProduct() {
      this.showSelectedDialog = true
    },

    onSelectedResult(record) {
      this.ruleForm.limitProId = record.limitProId
      this.ruleForm.limitProCatalogId = record.limitProCatalogId
      this.showSelectedDialog = false
    },
    saveEvent() {
      this.getSubmitFormParams('form').then(values => {
        this.saveRequest()
      }).catch(reason => this.getLogUtils().errorWithTag('validateFormParams', this.ruleForm))
    },
    saveRequest() {
      this.saveLoading = true
      this.ruleForm.limitMerchantId = this.queryParams.limitMerchantId
      this.getHttpServices().getApiService().post('limit/group/save', this.ruleForm)
        .then(res => {
          this.showDialog = false
          this.$message.success('商品添加成功')
          this.$refs.table.refresh(true)
        }).finally(() => this.saveLoading = false)
    }
  }

}
</script>
<style scoped>
.image {
  height: 104px;
  width: 104px;
}
</style>